import React, { useState, useEffect, useRef } from "react";
import { Link, NavLink, useHistory, useLocation } from "react-router-dom";
import "./style.scss";
import { Nav } from "reactstrap";
import useFetchUserData from "hooks/useAuthUserData";
import PerfectScrollbar from "perfect-scrollbar";
import routes from "routes.js";
import { Modal } from "react-bootstrap";
import { useWeb3React } from "@web3-react/core";
import useAuth from "hooks/useAuth";

// Declare the component

function Sidebar(props) {
  const { account } = useWeb3React();
  console.log(account, "acccoumttttt");

  const { login, logout } = useAuth();

  const history = useHistory();
  const sidebar = useRef(null); // Reference for sidebar
  const [brandName, setBrandName] = useState(""); // State for brand name
  const [show, setShow] = useState(false); // Modal state

  const useData = useFetchUserData();
  const user = useData?.data?.data;
  // console.log(useData);
  // console.log(user);

  const router = useLocation();

  // Handle modal show and close
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // Initialize PerfectScrollbar for Windows platform
  useEffect(() => {
    let ps;
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(sidebar.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
    }
    return () => {
      if (ps) {
        ps.destroy(); // Cleanup when the component is unmounted
      }
    };
  }, []);

  // Get the brand name based on the current route
  const getBrand = () => {
    routes.forEach((prop) => {
      if (window.location.href.indexOf(prop.layout + prop.path) !== -1) {
        setBrandName(prop.name);
      }
    });
  };

  useEffect(() => {
    getBrand();
  }, []); // Only call once after the first render

  // Toggle sidebar visibility
  const openSidebar = () => {
    document.documentElement.classList.toggle("nav-open");
  };

  const handleLogOut = async () => {
    if (account) {
      const connectorId = window.localStorage.getItem("connectorId");
      await logout(connectorId);
      localStorage.removeItem("connectorId");
      localStorage.removeItem("flag");
    }
    localStorage.clear();
    history.push("/login");
  };

  const logoutHandle = async () => {
    if (account) {
      console.log("account in logout click", account);
      const connectorId = window.localStorage.getItem("connectorId");
      await logout(connectorId);
      localStorage.removeItem("connectorId");
      localStorage.removeItem("flag");
    } else {
      window.location.reload();
    }
  };

  const connectMetaMask1 = async () => {
    if (account) {
      const connectorId = window.localStorage.getItem("connectorId");
      await logout(connectorId);
      localStorage.removeItem("connectorId");
      localStorage.removeItem("flag");
    } else {
      login("injected");
      localStorage.setItem("connectorId", "injected");
      localStorage.setItem("flag", "true");
      handleClose();
    }
  };

  return (
    <>
      <div
        className="sidebar"
        data-color={props.bgColor}
        data-active-color={props.activeColor}
      >
        <div className="logo for-mobilesidebar-sm">
          <Link to="/clinic/dashboard" className="simple-text logo-mini">
            <div className="logo-img text-left">
              <img src="\logo.svg" alt="react-logo" />
            </div>
          </Link>
          <img
            src="/assets/images/Close.svg"
            alt="img"
            className="img-fluid img-close d-none"
            onClick={openSidebar}
          />
        </div>
        <div className="mblnavbtns d-none">
          <div className="inputdiv">
            <input
              type="text"
              id="fname"
              name="fname"
              className="inputnavvv"
              placeholder="Search "
            />
            {/* <img className='imgwhitesearch' src='\assets\Searchwhite.svg' alt='search' /> */}

            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              className="imgwhitesearch"
            >
              <path
                d="M8.25 14.25C11.5637 14.25 14.25 11.5637 14.25 8.25C14.25 4.93629 11.5637 2.25 8.25 2.25C4.93629 2.25 2.25 4.93629 2.25 8.25C2.25 11.5637 4.93629 14.25 8.25 14.25Z"
                stroke="#7E7E7E"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M15.75 15.7498L12.4875 12.4873"
                stroke="#7E7E7E"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          {account ? (
            <>
              <button className="navcommonbtn" onClick={logoutHandle}>
                Disconnect
              </button>
              <p>
                {account
                  ? `${account?.slice(0, 6)}...${account?.slice(-4)}`
                  : "N/A"}
              </p>
            </>
          ) : (
            <button className="navcommonbtn" onClick={handleShow}>
              Connect Wallet
            </button>
          )}
          <button className="whitebtn">
            <div className="whitebtnimg">
              <img
                src={user ? user?.profileImage : null}
                alt="btninnerimg"
                className="btninnerimg"
              />
            </div>
            <p className="btninnerpara">
              {user ? (user.name ? user?.name : user?.email.split("@")[0]) : ""}
            </p>
          </button>
        </div>
        <div className="sidebar-wrapper" ref={sidebar}>
          <Nav>
            <li>
              <NavLink
                to="/user/dashboard"
                className={({ isActive }) =>
                  `nav-link ${isActive ? "active" : ""}`
                }
              >
                <div className="fstdivmain">
                  <div className="inersecdiv">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="21"
                      viewBox="0 0 20 21"
                      fill="none"
                    >
                      <path
                        d="M4.16663 8.49577H5.83329C7.49996 8.49577 8.33329 7.66243 8.33329 5.99577V4.3291C8.33329 2.66243 7.49996 1.8291 5.83329 1.8291H4.16663C2.49996 1.8291 1.66663 2.66243 1.66663 4.3291V5.99577C1.66663 7.66243 2.49996 8.49577 4.16663 8.49577Z"
                        stroke="#FF8A00"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M14.1666 8.49577H15.8333C17.5 8.49577 18.3333 7.66243 18.3333 5.99577V4.3291C18.3333 2.66243 17.5 1.8291 15.8333 1.8291H14.1666C12.5 1.8291 11.6666 2.66243 11.6666 4.3291V5.99577C11.6666 7.66243 12.5 8.49577 14.1666 8.49577Z"
                        stroke="#FF8A00"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M14.1666 18.4958H15.8333C17.5 18.4958 18.3333 17.6624 18.3333 15.9958V14.3291C18.3333 12.6624 17.5 11.8291 15.8333 11.8291H14.1666C12.5 11.8291 11.6666 12.6624 11.6666 14.3291V15.9958C11.6666 17.6624 12.5 18.4958 14.1666 18.4958Z"
                        stroke="#FF8A00"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M4.16663 18.4958H5.83329C7.49996 18.4958 8.33329 17.6624 8.33329 15.9958V14.3291C8.33329 12.6624 7.49996 11.8291 5.83329 11.8291H4.16663C2.49996 11.8291 1.66663 12.6624 1.66663 14.3291V15.9958C1.66663 17.6624 2.49996 18.4958 4.16663 18.4958Z"
                        stroke="#FF8A00"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <p>Dashboard</p>
                  </div>
                  <div className="inersecdivssss">
                    {router.pathname === "/user/dashboard" && (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="9"
                        height="10"
                        viewBox="0 0 9 10"
                        fill="none"
                        className="active-indicator"
                      >
                        <circle cx="4.5" cy="5" r="4" fill="#FF8A00" />
                      </svg>
                    )}
                  </div>
                </div>
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/user/referral"
                className={({ isActive }) =>
                  `nav-link ${isActive ? "active" : ""}`
                }
              >
                <div className="fstdivmain">
                  <div className="inersecdiv">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="21"
                      viewBox="0 0 20 21"
                      fill="none"
                    >
                      <path
                        d="M7.63332 9.22107C7.54999 9.21274 7.44999 9.21274 7.35832 9.22107C5.37499 9.15441 3.79999 7.52941 3.79999 5.52941C3.79999 3.48774 5.44999 1.82941 7.49999 1.82941C9.54165 1.82941 11.2 3.48774 11.2 5.52941C11.1917 7.52941 9.61665 9.15441 7.63332 9.22107Z"
                        stroke="#FF8A00"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M13.675 3.49609C15.2916 3.49609 16.5916 4.80443 16.5916 6.41276C16.5916 7.98776 15.3417 9.27109 13.7833 9.32943C13.7167 9.32109 13.6417 9.32109 13.5667 9.32943"
                        stroke="#FF8A00"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M3.46666 12.2961C1.45 13.6461 1.45 15.8461 3.46666 17.1878C5.75833 18.7211 9.51666 18.7211 11.8083 17.1878C13.825 15.8378 13.825 13.6378 11.8083 12.2961C9.525 10.7711 5.76666 10.7711 3.46666 12.2961Z"
                        stroke="#FF8A00"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M15.2833 16.8294C15.8833 16.7044 16.45 16.4627 16.9167 16.1044C18.2167 15.1294 18.2167 13.5211 16.9167 12.5461C16.4583 12.1961 15.9 11.9627 15.3083 11.8294"
                        stroke="#FF8A00"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <p>Referral</p>
                  </div>
                  <div className="inersecdivssss">
                    {router.pathname === "/user/referral" && (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="9"
                        height="10"
                        viewBox="0 0 9 10"
                        fill="none"
                        className="active-indicator"
                      >
                        <circle cx="4.5" cy="5" r="4" fill="#FF8A00" />
                      </svg>
                    )}
                  </div>
                </div>
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/user/transactionactivity"
                className={({ isActive }) =>
                  `nav-link ${isActive ? "active" : ""}`
                }
              >
                <div className="fstdivmain">
                  <div className="inersecdiv">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="21"
                      viewBox="0 0 20 21"
                      fill="none"
                    >
                      <path
                        d="M7.50002 18.4961H12.5C16.6667 18.4961 18.3334 16.8294 18.3334 12.6627V7.66274C18.3334 3.49607 16.6667 1.82941 12.5 1.82941H7.50002C3.33335 1.82941 1.66669 3.49607 1.66669 7.66274V12.6627C1.66669 16.8294 3.33335 18.4961 7.50002 18.4961Z"
                        stroke="#FF8A00"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M12.9167 15.5794C13.8333 15.5794 14.5833 14.8294 14.5833 13.9128V6.41276C14.5833 5.49609 13.8333 4.74609 12.9167 4.74609C12 4.74609 11.25 5.49609 11.25 6.41276V13.9128C11.25 14.8294 11.9917 15.5794 12.9167 15.5794Z"
                        stroke="#FF8A00"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M7.08335 15.5794C8.00002 15.5794 8.75002 14.8294 8.75002 13.9127V10.9961C8.75002 10.0794 8.00002 9.32941 7.08335 9.32941C6.16669 9.32941 5.41669 10.0794 5.41669 10.9961V13.9127C5.41669 14.8294 6.15835 15.5794 7.08335 15.5794Z"
                        stroke="#FF8A00"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <p>Transaction Activity</p>
                  </div>
                  <div className="inersecdivssss">
                    {router.pathname === "/user/transactionactivity" && (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="9"
                        height="10"
                        viewBox="0 0 9 10"
                        fill="none"
                        className="active-indicator"
                      >
                        <circle cx="4.5" cy="5" r="4" fill="#FF8A00" />
                      </svg>
                    )}
                  </div>
                </div>
              </NavLink>
            </li>

            {/* <li>
              <Link
                to="/user/myproducts" // Correct the "to" attribute by enclosing the URL in quotes
                className={
                  "nav-link " + (brandName === 'Users' || brandName === 'Product Details' || brandName === 'Edit Product Details' || brandName === 'Create Project' ? "active" : "")
                }
              >
                <div className="fstdivmain">
                  <div className="inersecdiv">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none" className="iconns">
                      <path d="M7.63338 9.22126C7.55005 9.21292 7.45005 9.21292 7.35838 9.22126C5.37505 9.15459 3.80005 7.52959 3.80005 5.52959C3.80005 3.48792 5.45005 1.82959 7.50005 1.82959C9.54172 1.82959 11.2 3.48792 11.2 5.52959C11.1917 7.52959 9.61672 9.15459 7.63338 9.22126Z" stroke="#FF8A00" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M13.675 3.49609C15.2916 3.49609 16.5916 4.80443 16.5916 6.41276C16.5916 7.98776 15.3417 9.27109 13.7833 9.32943C13.7167 9.32109 13.6417 9.32109 13.5667 9.32943" stroke="#FF8A00" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M3.4666 12.2961C1.44993 13.6461 1.44993 15.8461 3.4666 17.1878C5.75827 18.7211 9.5166 18.7211 11.8083 17.1878C13.8249 15.8378 13.8249 13.6378 11.8083 12.2961C9.52494 10.7711 5.7666 10.7711 3.4666 12.2961Z" stroke="#FF8A00" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M15.2834 16.8296C15.8834 16.7046 16.4501 16.4629 16.9168 16.1046C18.2168 15.1296 18.2168 13.5213 16.9168 12.5463C16.4584 12.1963 15.9001 11.9629 15.3084 11.8296" stroke="#FF8A00" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <p className="">Users</p>
                  </div>
                  <div className="inersecdivssss">
                    {brandName === "Users" && (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="9"
                        height="10"
                        viewBox="0 0 9 10"
                        fill="none"
                        className="active-indicator"
                      >
                        <circle cx="4.5" cy="5.1626" r="4.5" fill="#FF8A00" />
                      </svg>
                    )}
                  </div>
                </div>


              </Link>
            </li> */}
            <li>
              <Link
                to="/user/purchasednfts" // Enclosed the URL path in quotes
                className={
                  "nav-link " +
                  (router.pathname === "/user/purchasednfts" ? "active" : "")
                }
              >
                <div className="fstdivmain">
                  <div className="inersecdiv">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="21"
                      viewBox="0 0 20 21"
                      fill="none"
                    >
                      <path
                        d="M6.25 6.55442V5.74609C6.25 3.87109 7.75833 2.02942 9.63333 1.85442C11.8667 1.63776 13.75 3.39609 13.75 5.58776V6.73776"
                        stroke="#FF8A00"
                        stroke-width="1.5"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M7.5001 18.4961H12.5001C15.8501 18.4961 16.4501 17.1544 16.6251 15.5211L17.2501 10.5211C17.4751 8.48776 16.8918 6.82942 13.3334 6.82942H6.66677C3.10843 6.82942 2.5251 8.48776 2.7501 10.5211L3.3751 15.5211C3.5501 17.1544 4.1501 18.4961 7.5001 18.4961Z"
                        stroke="#FF8A00"
                        stroke-width="1.5"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M12.9128 10.1627H12.9203"
                        stroke="#FF8A00"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M7.07884 10.1627H7.08632"
                        stroke="#FF8A00"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <p className="">Purchased NFTs</p>
                  </div>
                  <div className="inersecdivssss">
                    {router.pathname === "/user/purchasednfts" && (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="9"
                        height="10"
                        viewBox="0 0 9 10"
                        fill="none"
                        className="active-indicator"
                      >
                        <circle cx="4.5" cy="5.1626" r="4.5" fill="#FF8A00" />
                      </svg>
                    )}
                  </div>
                </div>
              </Link>
            </li>

            <li>
              <Link
                to={{
                  pathname: "/user/editprofile",
                  state: { user: user }, // Replace yourUserObject with the actual user data
                }}
                className={
                  "nav-link " +
                  (router.pathname === "/user/editprofile" ? "active" : "")
                }
              >
                <div className="fstdivmain">
                  <div className="inersecdiv">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="21"
                      viewBox="0 0 20 21"
                      fill="none"
                    >
                      <path
                        d="M11.05 3.16275L4.20829 10.4044C3.94996 10.6794 3.69996 11.2211 3.64996 11.5961L3.34162 14.2961C3.23329 15.2711 3.93329 15.9378 4.89996 15.7711L7.58329 15.3128C7.95829 15.2461 8.48329 14.9711 8.74162 14.6878L15.5833 7.44609C16.7666 6.19609 17.3 4.77109 15.4583 3.02942C13.625 1.30442 12.2333 1.91275 11.05 3.16275Z"
                        stroke="#FF8A00"
                        stroke-width="1.5"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M9.90845 4.37108C10.2668 6.67108 12.1334 8.42941 14.4501 8.66275"
                        stroke="#FF8A00"
                        stroke-width="1.5"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M2.5 18.4961H17.5"
                        stroke="#FF8A00"
                        stroke-width="1.5"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <p className="">Edit Profile</p>
                  </div>
                  <div className="inersecdivssss">
                    {router.pathname === "/user/editprofile" && (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="9"
                        height="10"
                        viewBox="0 0 9 10"
                        fill="none"
                        className="active-indicator"
                      >
                        <circle cx="4.5" cy="5.1626" r="4.5" fill="#FF8A00" />
                      </svg>
                    )}
                  </div>
                </div>
              </Link>
            </li>

            {/* 
<li>
  <Link
    to="/user/productscatalog" // Enclosed the URL path in quotes
    className={
      "nav-link " + (brandName === "Products Catalog" || brandName === 'Products Catalog Details' ? "active" : "")
    }
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" className="iconns">
      <path d="M2.6416 6.20001L9.99993 10.4583L17.3083 6.22501" stroke="#797979" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10 18.0083V10.45" stroke="#797979" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8.27454 2.06667L3.82454 4.53333C2.81621 5.09167 1.99121 6.49167 1.99121 7.64167V12.35C1.99121 13.5 2.81621 14.9 3.82454 15.4583L8.27454 17.9333C9.22454 18.4583 10.7829 18.4583 11.7329 17.9333L16.1829 15.4583C17.1912 14.9 18.0162 13.5 18.0162 12.35V7.64167C18.0162 6.49167 17.1912 5.09167 16.1829 4.53333L11.7329 2.05833C10.7745 1.53333 9.22454 1.53333 8.27454 2.06667Z" stroke="#797979" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
    <p className="">Products Catalog</p>
    {brandName === "Products Catalog" && (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="9"
        height="10"
        viewBox="0 0 9 10"
        fill="none"
        className="active-indicator"
      >
        <circle cx="4.5" cy="5.1626" r="4.5" fill="#FF8A00" />
      </svg>
    )}
  </Link>
</li> */}
          </Nav>
          <div className="logout">
            <button className="btn-logout" onClick={handleLogOut}>
              Log Out
            </button>
          </div>
        </div>
      </div>

      {/* Modal for user */}
      <Modal className="ambmodalmain" show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Connect Your Wallet</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <p className="connect">Please connect your crypto wallet.</p>
            <div className="meta lastmeta" onClick={() => connectMetaMask1()}>
              <div className="inermeta">
                <img src="\assets\dashboard\metamask.svg" />
                <p> Metamask</p>
              </div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M7 17L17 7M17 7H9M17 7V15"
                  stroke="black"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div className="meta">
              <div className="inermeta">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                >
                  <path
                    d="M6.11994 9.12561C10.1953 4.95813 16.8047 4.95813 20.8801 9.12561L21.3701 9.62382C21.5765 9.83253 21.5765 10.1692 21.3701 10.3779L19.6936 12.0947C19.5904 12.1957 19.4292 12.1957 19.326 12.0947L18.649 11.4012C15.8053 8.49274 11.1947 8.49274 8.35105 11.4012L7.62884 12.1418C7.52566 12.2428 7.36446 12.2428 7.26128 12.1418L5.57828 10.4317C5.37194 10.223 5.37194 9.88639 5.57828 9.67768L6.11994 9.12561ZM24.3492 12.6737L25.8452 14.202C26.0516 14.4107 26.0516 14.7473 25.8452 14.956L19.1068 21.8435C18.9004 22.0522 18.5716 22.0522 18.3717 21.8435L13.5935 16.9556C13.5419 16.9017 13.4581 16.9017 13.4065 16.9556L8.62832 21.8435C8.42198 22.0522 8.09311 22.0522 7.89322 21.8435L1.15476 14.956C0.948414 14.7473 0.948414 14.4107 1.15476 14.202L2.65076 12.6737C2.85711 12.465 3.18597 12.465 3.38587 12.6737L8.16404 17.5615C8.21563 17.6154 8.29946 17.6154 8.35105 17.5615L13.1292 12.6737C13.3356 12.465 13.6644 12.465 13.8643 12.6737L18.6425 17.5615C18.6941 17.6154 18.7779 17.6154 18.8295 17.5615L23.6077 12.6737C23.814 12.465 24.1429 12.465 24.3492 12.6737Z"
                    fill="#007FFF"
                  />
                </svg>
                <p> Connect Wallet</p>
              </div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M7 17L17 7M17 7H9M17 7V15"
                  stroke="black"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Sidebar;
